import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ErrorMessagePipe } from './error-message.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [ErrorMessagePipe],
  exports: [ErrorMessagePipe]
})
export class ErrorMessagePipeModule {}
